import { Model } from 'ords/dist/model/model';

export class AssignmentPart extends Model {
    isExplanation() {
        return this.type === 1;
    }

    isAssignment() {
        return this.type === 2;
    }

    isExplanationText() {
        return this.isExplanation() && this.sub_type === 1;
    }

    isExplanationImage() {
        return this.isExplanation() && this.sub_type === 2;
    }

    isExplanationVideo() {
        return this.isExplanation() && this.sub_type === 3;
    }

    isExplanationAttachment() {
        return this.isExplanation() && this.sub_type === 4;
    }

    isExplanationAudio() {
        return this.isExplanation() && this.sub_type === 6;
    }

    isExplanationWithFiles() {
        return (
            this.isExplanationImage() ||
            this.isExplanationVideo() ||
            this.isExplanationAttachment() ||
            this.isExplanationAudio()
        );
    }

    isExplanationYoutubeLink() {
        return this.isExplanation() && this.sub_type === 5;
    }

    isAssignmentQuestionAndAnswer() {
        return this.isAssignment() && this.sub_type === 1;
    }

    isAssignmentFileUpload() {
        return this.isAssignment() && this.sub_type === 2;
    }

    isAssignmentText() {
        return this.isAssignment() && this.sub_type === 3;
    }

    isAssignmentEditor() {
        return this.isAssignment() && this.sub_type === 4;
    }

    isAnAssignmentList() {
        return this.isAssignmentStandardList() || this.isAssignmentColorList() || this.isAssignmentCheckList();
    }

    isAssignmentStandardList() {
        return this.isAssignment() && this.sub_type === 5;
    }

    isAssignmentColorList() {
        return this.isAssignment() && this.sub_type === 6;
    }

    isAssignmentCheckList() {
        return this.isAssignment() && this.sub_type === 7;
    }

    getNameOrder() {
        let x = 0;

        for (const page of this.page.sub_assignment.pages) {
            for (const part of page.parts) {
                if (part.isExplanation()) {
                    continue;
                }
                x++;
                if (part.id === this.id) {
                    return x;
                }
            }
        }
    }

    getListOptionByValue(value) {
        for (const option of this.list_options) {
            if (option.value === value) {
                return option;
            }
        }
        return null;
    }

    hasAnswer() {
        return !!this.answers.length;
    }

    getAnswer() {
        return this.hasAnswer() ? this.answers[0] : null;
    }

    canAddToProfile() {
        if (!this.hasAnswer()) {
            return false;
        }

        if (this.isAssignmentFileUpload() || this.isAssignmentEditor()) {
            return !!this.getAnswer().files.length;
        } else if (this.isAssignmentQuestionAndAnswer() || this.isAssignmentText()) {
            return !!this.getAnswer().text.value;
        }
    }

    getAssignmentPartType() {
        if (this.type === 1) {
            switch (this.sub_type) {
                case 1:
                    return 'Tekst';

                case 2:
                    return 'Afbeelding';

                case 3:
                    return 'Video uitleg';

                case 4:
                    return 'Bijlage';

                case 5:
                    return 'Youtube link';

                case 6:
                    return 'Audio';
            }
        } else if (this.type === 2) {
            switch (this.sub_type) {
                case 1:
                    return 'Vraag en antwoord';

                case 2:
                    return 'Bestand upload';

                case 3:
                    return 'Tekst';

                case 4:
                    return 'Verslag';

                case 5:
                    return 'Keuzelijst';

                case 6:
                    return 'Kleuren keuzelijst';

                case 7:
                    return 'Aankruisvakken';
                case 8:
                    return 'Match antwoord bij vraag';
                case 9:
                    return 'invuloefening';
            }
        }
    }
}

export const AssignmentPartModelConfig = {
    name: 'assignmentPart',
    model: AssignmentPart,
    relations: [
        { name: 'text', model_name: 'assignmentPartText', type: 'hasOne' },
        { name: 'video_link', model_name: 'assignmentPartVideoLink', type: 'hasOne' },
        { name: 'part_files', model_name: 'assignmentPartFile', type: 'hasMany' },
        { name: 'list_options', model_name: 'assignmentPartListOption', type: 'hasMany' },
        { name: 'list_items', model_name: 'assignmentPartListItem', type: 'hasMany' },
        { name: 'answers', model_name: 'assignmentPartAnswer', type: 'hasMany' },
        { name: 'page', model_name: 'assignmentPage', type: 'hasOne' },
    ],
};
